/* eslint-disable react/style-prop-object */
import React from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../Helpers/Input/Input";
import Button from "../../../../../../Helpers/Button/Button";
import {
	useGetSpecificDeviceQuery,
	useUpdateDeviceByIdMutation,
} from "../../../../../../../Redux/Devicestwo";
import { toast } from "react-toastify";
import trans from "../../../../../../../utils";
import { useSelector } from "react-redux";
import {
	VolumeInputValue,
	VolumeValue,
} from "../../../../../../../JsHelpers/PlatformUnits";

const FuelIncreaseThreshold = ({
	device,
	setControlsPopup,
	setIsControlsPopup,
}) => {
	const {
		data: oldData,
		refetch,
		isLoading,
	} = useGetSpecificDeviceQuery(device?.id, { skip: !device?.id });
	const [updateDeviceById] = useUpdateDeviceByIdMutation();
	const inf = useSelector((state) => state.users.user);

	const formik = useFormik({
		initialValues: {
			FuelIncreaseThreshold:
				VolumeInputValue(
					oldData?.length > 0 && oldData?.[0].attributes?.FuelIncreaseThreshold,
					inf.attributes.volumeUnit || "ltr"
				) || "",
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			FuelIncreaseThreshold: Yup.number()
				.min(1, trans("Fuel Increase Threshold must be more than 0"))
				.required(trans("Fuel Increase Threshold is required")),
		}),
		onSubmit: async (val) => {
			try {
				const body = {
					id: device?.id,
					attributes: {
						speedLimit: oldData?.[0].attributes?.speedLimit,
						FuelIncreaseThreshold: VolumeValue(
							val.FuelIncreaseThreshold,
							inf.attributes?.volumeUnit || "ltr"
						),
						fuelDropThreshold: oldData?.[0].attributes?.fuelDropThreshold,
					},
					groupId: oldData?.[0].groupId,
					calendarId: oldData?.[0].calendarId,
					name: oldData?.[0].name,
					uniqueId: oldData?.[0].uniqueId,
					status: oldData?.[0].status,
					lastUpdate: oldData?.[0].lastUpdate,
					positionId: oldData?.[0].positionId,
					phone: oldData?.[0].phone,
					model: oldData?.[0].model,
					contact: oldData?.[0].contact,
					category: oldData?.[0].category,
					disabled: oldData?.[0].disabled,
					expirationTime: oldData?.[0].expirationTime,
				};
				await updateDeviceById({ id: device?.id, val: body }).unwrap();
				await refetch();
				setControlsPopup("");
				setIsControlsPopup(false);
				toast.success(
					trans("Fuel Increase Threshold has been set successfully"),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
			} catch (error) {
				toast.error(
					trans(
						"Error while setting fuel increase threshold, please try again later"
					),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
			}
		},
	});

	if (isLoading) return <>Loading...</>;

	return (
		<form onSubmit={formik.handleSubmit}>
			<div>
				<Input
					title={trans("Enter Fuel Increase Threshold")}
					type="number"
					placeholder={`100 ${trans(inf.attributes?.volumeUnit || "ltr")}`}
					id="FuelIncreaseThreshold"
					name="FuelIncreaseThreshold"
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values.FuelIncreaseThreshold}
				/>
				{formik.touched.FuelIncreaseThreshold &&
				formik.errors.FuelIncreaseThreshold ? (
					<div className="validation">
						{formik.errors.FuelIncreaseThreshold}
					</div>
				) : null}
				<div className="w-100 flex-row justify-end mt-12">
					<Button text={trans("Save")} htmlType="submit" type="primary" />
				</div>
			</div>
		</form>
	);
};

export default FuelIncreaseThreshold;
